import type { MailboxInfo } from "owa-client-types";
import getGlobalSettingsAccountMailboxInfo from "../selectors/getGlobalSettingsAccountMailboxInfo";
import { isSameCoprincipalAccountMailboxInfos } from "owa-client-types";

export default function isMailboxSameAccountAsGlobalSettingsAccount(mailboxInfo: MailboxInfo): boolean {
    return isSameCoprincipalAccountMailboxInfos(mailboxInfo, getGlobalSettingsAccountMailboxInfo());
}
